/* =====================================================================
   ExtraCM · tema de Shopify · portada
   Barra de navegación, animaciones, vídeos y el selector de producto
   (altura + talla + pares) que añade al carrito de theme.js.
   ===================================================================== */
(function () {
  'use strict';
  var ECM = window.ECM || {}, TH = window.ECMTheme;
  var $ = function (id) { return document.getElementById(id); };
  var t = TH ? TH.t : function (s) { return s; };
  var tt = TH && TH.tt ? TH.tt : t;   // texto plano para textContent (t() viene escapado)

  /* navbar + menú móvil */
  (function () {
    var nav = $('navbar'); if (!nav) return;
    var onScroll = function () { nav.classList.toggle('scrolled', window.scrollY > 50); };
    window.addEventListener('scroll', onScroll, { passive: true }); onScroll();
    // (el menú lateral lo abre theme.js, común a todas las páginas)
  })();

  /* aparición al hacer scroll */
  (function () {
    var items = document.querySelectorAll('.reveal');
    if (!items.length || !('IntersectionObserver' in window)) { items.forEach(function (i) { i.classList.add('in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    items.forEach(function (i) { io.observe(i); });
  })();

  /* vídeos UGC: sonido y reproducción al entrar en pantalla */
  (function () {
    var ICON_MUTED = '<svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M2 6h3l4-3v10l-4-3H2z"/><line x1="11" y1="6" x2="14" y2="9" stroke-linecap="round"/><line x1="14" y1="6" x2="11" y2="9" stroke-linecap="round"/></svg>';
    var ICON_ON = '<svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M2 6h3l4-3v10l-4-3H2z"/><path d="M11 5c1.5 1 1.5 5 0 6" stroke-linecap="round"/><path d="M13 3c2.5 2 2.5 8 0 10" stroke-linecap="round"/></svg>';
    document.querySelectorAll('.ugc__item').forEach(function (item) {
      var video = item.querySelector('video'), button = item.querySelector('.ugc__item__sound');
      if (!video || !button) return;
      button.addEventListener('click', function (e) {
        e.stopPropagation();
        var muting = !video.muted;
        if (!muting) document.querySelectorAll('.ugc__item video').forEach(function (v) { v.muted = true; });
        video.muted = muting;
        button.innerHTML = video.muted ? ICON_MUTED : ICON_ON;
      });
    });
    var vs = document.querySelectorAll('.ugc__item video'); if (!vs.length) return;
    if (!('IntersectionObserver' in window)) { vs.forEach(function (v) { v.preload = 'metadata'; var p = v.play(); if (p && p.catch) p.catch(function () {}); }); return; }
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { var v = e.target; if (e.isIntersecting) { if (v.preload === 'none') v.preload = 'auto'; var p = v.play(); if (p && p.catch) p.catch(function () {}); } else v.pause(); });
    }, { rootMargin: '200px' });
    vs.forEach(function (v) { io.observe(v); });
  })();

  if (!TH || !ECM.products) return;
  var CUR = TH.CUR;

  /* ---- precios fijos de la portada → precios de Shopify del mercado ---- */
  function base(h) { var p = ECM.products[h]; return p ? p.price / 100 : null; }
  function was(h) { var b = base(h); return b == null ? null : b + (h === 'bundle' ? CUR.bundleSurplus : CUR.surplus); }
  document.querySelectorAll('.bestseller, .size-card').forEach(function (card) {
    var trig = card.querySelector('[data-cart-open]'); if (!trig) return;
    var h = trig.getAttribute('data-cart-open'), b = base(h); if (b == null) return;
    var now = card.querySelector('.bestseller__price-now, .size-card__price'), w = card.querySelector('.bestseller__price-was');
    if (now) now.textContent = TH.moneyMajor(b);
    if (w) w.textContent = TH.moneyMajor(was(h));
  });
  document.querySelectorAll('.cart-height').forEach(function (b) {
    var h = b.dataset.height, p = b.querySelector('.cart-height__price'), v = base(h);
    if (p && v != null) p.textContent = TH.moneyMajor(v);
  });
  // 24-oct-2026: el "ahorra 25 %" del pack de 3 alturas era fijo; se calcula con los precios del mercado
  // (23 % con 94,99 € frente a 3 × 40,99 €). En japonés la insignia es un importe ("¥4,700お得"), no un %.
  (function () {
    var b5 = base('5'), bb = base('bundle'); if (!(b5 > 0 && bb > 0)) return;
    var bw = bb + (CUR.bundleSurplus || 0), pct = Math.round((1 - bb / bw) * 100); if (!(pct > 0 && pct < 90)) return;   // sobre el tachado (3 × 49,99), como los packs
    var amt = TH.moneyMajor(bw - bb), els = [].slice.call(document.querySelectorAll('.cart-height[data-height="bundle"] .cart-height__badge'));
    var MONEY = /[¥€£$]\s?[\d.,]+|[\d.,]+\s?(€|zł|Kč)|S\/\s?[\d.,]+/;
    document.querySelectorAll('.bestseller, .size-card').forEach(function (card) {
      if (!card.querySelector('[data-cart-open="bundle"]')) return;
      card.querySelectorAll('[class*="badge"], [class*="tag"]').forEach(function (e) { els.push(e); });
      // la lista de la tarjeta lleva "Ahorra 22 € frente a comprarlas por separado" fijo: también se recalcula
      card.querySelectorAll('li').forEach(function (e) { if (MONEY.test(e.textContent)) els.push(e); });
    });
    els.forEach(function (el) {
      var txt = el.textContent;
      if (/\d+\s?%/.test(txt)) el.textContent = txt.replace(/\d+(?=\s?%)/, pct);
      else if (MONEY.test(txt)) el.textContent = txt.replace(MONEY, amt);
    });
  })();
  // unidad: en los mercados métricos las alturas fijas pasan a centímetros
  if (CUR.unit === 'cm') {
    var uMap = { '+1.2"': '+3 cm', '+2.0"': '+5 cm', '+2"': '+5 cm', '+2.8"': '+7 cm' };
    document.querySelectorAll('.size-card__height, .cart-height__name, .callout__title .accent').forEach(function (el) {
      var k = el.textContent.trim(); if (uMap[k]) el.textContent = uMap[k];
    });
  }
  // tallas en EE. UU. y Canadá (inglés): numeración americana
  if (TH.sizeSystem()[1] === 'us') {
    var R = { 'UK 2–4': 'US 3–5', 'UK 5–6': 'US 6–7', 'UK 7–9': 'US 8–10', 'UK 10–11': 'US 11–12' };
    document.querySelectorAll('.cart-size__range, .step__size-badge').forEach(function (e) {
      var s = e.textContent.trim(); Object.keys(R).forEach(function (k) { if (s.indexOf(k) !== -1) e.textContent = s.replace(k, R[k]); });
    });
  }

  /* ---- selector de producto (modal) ---- */
  // packs del mentor (23-oct-2026): los mismos porcentajes que la ficha y los descuentos de Shopify
  var OFF = { 1: 0, 2: 0.1220, 3: 0.1952, 4: 0.1952, 5: 0.2684 };
  var QDEC = (TH.FMT && TH.FMT.decimals === 0) ? 1 : 100;   // CLP/COP/JPY: Shopify trunca el descuento a la unidad
  function qp(b, o) { return b - Math.floor(b * o * QDEC + 1e-9) / QDEC; }
  function perPairFor(h, qty) { return qp(base(h) || 0, OFF[Math.min(Math.max(qty, 1), 5)]); }

  var overlay = $('overlay'), modal = $('selectorModal'), modalClose = $('selectorClose'), modalAdd = $('selectorAdd');
  if (!modal) return;
  var modalHeights = modal.querySelectorAll('.cart-height'), modalSizes = modal.querySelectorAll('.cart-size'), modalPacks = modal.querySelectorAll('.cart-pack');
  var selectedHeight = null, selectedSize = null, selectedPack = 2;   // 2 pares por defecto (23-oct)

  function lockScroll(lock) { document.body.style.overflow = lock ? 'hidden' : ''; }
  function openModal(preset) {
    resetModal(); if (preset) selectHeight(String(preset));
    modal.classList.add('open'); overlay.classList.add('show'); modal.setAttribute('aria-hidden', 'false'); lockScroll(true);
  }
  function closeModal() {
    modal.classList.remove('open'); modal.setAttribute('aria-hidden', 'true');
    var drawerOpen = $('drawer') && $('drawer').classList.contains('open');
    if (!drawerOpen) { overlay.classList.remove('show'); lockScroll(false); }
  }
  function resetModal() {
    selectedHeight = null; selectedSize = null; selectedPack = 2;
    modalHeights.forEach(function (b) { b.classList.remove('active'); });
    modalSizes.forEach(function (b) { b.classList.remove('active'); });
    modalPacks.forEach(function (b) { b.classList.toggle('active', b.dataset.pack === '2'); });
    updateCta();
  }
  function selectHeight(h) { modalHeights.forEach(function (b) { var m = b.dataset.height === h; b.classList.toggle('active', m); if (m) selectedHeight = h; }); updatePackSaves(); updateCta(); }
  // ahorro de cada pack sobre el precio tachado (par + recargo del mercado), como en la ficha (23-oct)
  function updatePackSaves() {
    var h = selectedHeight || '5', C = TH.CUR || {}, was = perPairFor(h, 1) + (h === 'bundle' ? (C.bundleSurplus || 0) : (C.surplus || 0));
    if (!(was > 0)) return;
    modalPacks.forEach(function (b) {
      var n = parseInt(b.dataset.pack, 10), el = b.querySelector('.cart-pack__save');
      if (el && n > 1) el.textContent = tt('{pct}% off', { pct: Math.round((was - perPairFor(h, n)) / was * 100) });
    });
  }
  function selectSize(s) { modalSizes.forEach(function (b) { b.classList.toggle('active', b.dataset.size === s); }); selectedSize = s; updateCta(); }
  function selectPack(n) { selectedPack = parseInt(n, 10) || 1; modalPacks.forEach(function (b) { b.classList.toggle('active', parseInt(b.dataset.pack, 10) === selectedPack); }); updateCta(); }
  function updateCta() {
    var p = selectedHeight && ECM.products[selectedHeight], v = p && selectedSize && p.variants[selectedSize];
    modalAdd.disabled = !v;
    if (v) {
      var total = perPairFor(selectedHeight, selectedPack) * selectedPack;
      var packLabel = selectedHeight === 'bundle' ? (selectedPack === 1 ? t('1 pack') : t('{n} packs', { n: selectedPack })) : (selectedPack === 1 ? t('1 pair') : t('{n} pairs', { n: selectedPack }));
      modalAdd.innerHTML = t('Add to cart — {pack} · {price}', { pack: packLabel, price: TH.moneyMajor(total) });
    } else modalAdd.textContent = tt('Select height and size');
  }
  modalHeights.forEach(function (b) { b.addEventListener('click', function () { selectHeight(b.dataset.height); }); });
  updatePackSaves();
  modalSizes.forEach(function (b) { b.addEventListener('click', function () { selectSize(b.dataset.size); }); });
  modalPacks.forEach(function (b) { b.addEventListener('click', function () { selectPack(b.dataset.pack); }); });
  modalClose.addEventListener('click', closeModal);
  document.addEventListener('ecm:overlay', closeModal);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && modal.classList.contains('open')) closeModal(); });
  modalAdd.addEventListener('click', function () {
    var p = selectedHeight && ECM.products[selectedHeight], v = p && p.variants[selectedSize];
    if (!v) return;
    modalAdd.disabled = true;
    var h = selectedHeight, sz = selectedSize, q = selectedPack;
    TH.addWithProtection([{ id: v.id, quantity: selectedPack }]).then(function () {
      try { TH.trackAddToCart({ h: h, size: sz, qty: q, perPair: perPairFor(h, q), variantId: v.id, source: 'home' }); } catch (e) {}
      modalAdd.textContent = tt('✓ Added to cart'); modalAdd.style.background = '#1ED760';
      setTimeout(function () { closeModal(); setTimeout(function () { modalAdd.style.background = ''; updateCta(); TH.renderCart(); TH.openDrawer(); }, 350); }, 700);
    }).catch(function (e) { console.error(e); modalAdd.disabled = false; alert(t('There was an issue with your cart. Please refresh and try again.')); });
  });
  document.querySelectorAll('[data-cart-open]').forEach(function (el) {
    el.addEventListener('click', function (e) { e.preventDefault(); openModal(el.getAttribute('data-cart-open') || null); });
  });
})();
